export var DISCUSSION = 'discussion';
export var QUESTION = 'question';
export var isDiscussion = function (postType) {
    if (postType === void 0) { postType = DISCUSSION; }
    return postType === DISCUSSION;
};
export var isQuestion = function (postType) { return postType === QUESTION; };
//# sourceMappingURL=post-types.js.map